<template>
    <div class="updateActivity">
        <div class="title">
            标题：<input type="text" v-model="title">
        </div>
        <div class="upload">
            <el-upload class="upload-demo" :action="url" :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="uploadSuccedd" :multiple="true" show-file-list list-type="picture" :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary">点击新增图片</el-button>
                <div slot="tip" class="el-upload__tip">文件大小不能超过2M</div>
            </el-upload>
        </div>
        <div class="picList">
            <div class="picBox" v-for="(item,i) in picList" :key="i">
                <img :src="Baseurl+item" alt="">
                <el-button type="text" @click="removePic(i)">删除</el-button>
            </div>
        </div>
        <el-button type="primary" @click="onSubmit">保存</el-button>
    </div>
</template>

<script>
    import { getActivityImgsById, updateActivityImgs } from '../api/api.js'
    export default {
        name: 'updateActivity',
        created() {
            let id = this.$route.query.id;
            getActivityImgsById({ id: id }).then((res) => {
                this.title = res.data.data.title;
                this.activityImgId = res.data.data.activityImgId;
                if (res.data.data.companyNewsImg != null) {
                    this.picList = res.data.data.companyNewsImg.split(',');
                }
            })
        },
        data() {
            return {
                url: this.GLOBAL.uploderPicURL,
                Baseurl: this.GLOBAL.picURL,
                title: '',
                activityImgId: '',
                picList: [],
                newPicList: []
            }
        },
        methods: {
            handleRemove(file, fileList) {
                this.$message.warning(`成功删除文件，请重新选取文件`);
                for (let i = 0; i < fileList.length; i++) {
                    this.newPicList.push(fileList[i].response.data.filePath);
                }
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 图片上传成功钩子
            uploadSuccedd(file, fileList) {
                this.newPicList.push(file.data.filePath)
            },
            removePic(i) {
                this.picList.splice(i, 1)
            },
            onSubmit() {
                let imgStr = '';
                for (let i = 0; i < this.newPicList.length; i++) {
                    this.picList.push(this.newPicList[i])
                }
                for (let i = 0; i < this.picList.length; i++) {
                    if (i === this.picList.length - 1) {
                        imgStr += this.picList[i]
                    } else {
                        imgStr += this.picList[i] + ',';
                    }
                }
                updateActivityImgs({
                    title: this.title,
                    activityImgId: this.activityImgId,
                    companyNewsImg: imgStr,
                }).then((res) => {
                    if (res.status === 1) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$router.push({ path: '/ht_activity' });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .title {
        padding: 1% 0;
        color: #2e324f
    }

    .picBox {
        display: inline-block;
        width: 21%;
        margin-right: 1%;
        margin-bottom: 1%;
    }

    .picBox img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_updateActivity.vue